/**
 * Real explore (SIGHT-2217, looker-enterprise PR #521) - see
 * ../../../../../models/looker/modules/bidstream/rejectionReasons.ts for the
 * full field mapping/caveats.
 */
export const REJECTION_REASONS_QUERY = {
    view: "explore_bidstream",
    model: "client_analytics",
    fieldMap: {
        "explore_bidstream_base.failed_geo": "",
        "explore_bidstream_base.failed_dcat": "",
        "explore_bidstream_base.failed_badv": "",
        "explore_bidstream_base.failed_dealpub": "",
        "explore_bidstream_base.failed_floor": "",
        "explore_bidstream_base.failed_daypart": "",
        "explore_bidstream_base.failed_creative_vast": "",
        "explore_bidstream_base.failed_creative_asset": "",
        "explore_bidstream_base.failed_segments": "",
        "explore_bidstream_base.failed_freq_cap": "",
        "explore_bidstream_base.failed_allowance": "",
        "explore_bidstream_base.failed_bcat": "",
        "explore_bidstream_base.failed_placement": "",
        "explore_bidstream_base.failed_media_type": ""
    },
    filters: {
        "explore_bidstream_base.flt_lineitem_id": "",
        "explore_bidstream_base.flt_analysis_interval": ""
    },
    // Deliberately "1" - findItems/parseRejectionReasonsResponse assume one row per line item.
    limit: "1"
};
//# sourceMappingURL=query.js.map